module.exports = __webpack_public_path__ + "assets/img/04.efcb8d68.png";